import { createI18nText } from '@hilma/netina2all';

const helmetResource = createI18nText({
	he: {
		'site-title': 'מתנות קטנות- משלוחי מנות',
		'': {
			title: 'דף הבית',
			description: `מיזם "מתנות קטנות" הינו פרויקט ללא מטרות רווח מבית עמותת נתינת לולב אשר קם במטרה לתת נופך נוסף לתהליך רכישת משלוחי המנות- אנו פותחים בפניכם את האפשרות לרכוש משלוחי מנות, ובו בעת לתרום לעמותות שונות.`,
		},
		'how-it-works': {
			title: 'איך זה עובד',
			description: `מתנות קטנות מאפשרת לכם לרכוש משלוח מנות ולתרום לעמותה לבחירתך בצורה הפשוטה ביותר.
			נכנסים לאתר - בוחרים משלוח מנות ממגוון המשלוחים שבאתר - בוחרים מהיכן לאסוף את משלוח המנות - בוחרים לאיזו עמותה לתרום את כל הרווחים.`,
		},
		'distribution-stations': {
			title: 'תחנות חלוקה',
			description: `מאות תחנות חלוקה ממתינות לכם בכל רחבי הארץ, בכדי שתוכלו לאסוף את משלוח המנות שלכם כמה שיותר קרוב לביתכם.
            התחנות פזורות מהדרום ועד הצפון.`,
		},
		'associations': {
			title: 'העמותות',
			description: `מיזם מתנות קטנות מבית נתינת לולב מאפשר לכם לתרום לכ30 עמותות שונות ומגוונות. כך, ודאי תוכלו למצוא עמותה אליה תרצו לתרום את כל הרווחים מרכישת משלוחי המנות שלכם. ניתן לתרום דרכנו גם מתנות לאביונים.`,
		},
		'prices': {
			title: 'מחירון',
			description: ``,
		},
		'who-are-we': {
			title: 'מי אנחנו',
			description: `לאור הצלחת נתינת לולב החלטנו לפתוח את מיזם מתנות קטנות, אנו, קבוצה של חברים שהחליטה להקים את הפרויקט כדי לתת לכם את האפשרות לקנות משלוחי מנות ולתרום את כל הרווחים לצדקה.
			חשוב לציין כי כולנו מתנדבים בעמותה ולא מקבלים שכר כלל.`,
		},
		'common-questions': {
			title: 'שאלות נפוצות',
			description: `מיזם מתנות קטנות מבית נתינת לולב הוא פשוט וקל. עדיין לא הבנתם איך זה עובד? מהי רמת הכשרות? אנחנו כאן עם כל השאלות וכל התשובות עבורכם.`,
		},
		'contact-us': {
			title: 'צור קשר',
			description: `מתנות קטנות מבית נתינת לולב זמינים וקשובים לכל פניה או בקשה. אתם מוזמנים ליצור איתנו קשר ואנו נחזור אליכם בהקדם.`,
		},
		'purchase': {
			title: 'רכישה',
			description: `מתנות קטנות מאפשרת לכם לרכוש את משלוח המנות אותו אתם רוצים לתת השנה בצורה הפשוטה והקלה ביותר, כל מה שנשאר לכם זה להיכנס ולרכוש את משלוח המנות בו אתם מעוניינים ומכאן הכול יהיה פשוט ומסודר`,
		},
		'login': {
			title: 'התחברות',
			description: `באזור האישי תוכלו למצוא את ההזמנות שכבר ביצעתם ולבצע בהם שינויים כמו שינוי תחנת חלוקה, ביטול ההזמנה וגם להדפיס העתק של הקבלות של הרכישות שבצעתם`
		},
		'profile': {
			title: 'אזור אישי',
			description: ``
		}
	},
	en: { // !!!!!!!!!!!!!!!
		'site-title': 'Matanot Ktanot - Mishlochey Manot',
		'': {
			title: 'Home Page',
			description: `“Matanot Ktanot"” is a non-profit organization that allows you to purchase the four species quickly and easily while at the same donating the proceeds of the sale to a charity of your choosing.`
		},
		'how-it-works': {
			title: 'How it Works',
			description: `Order a Mishloah Manot on the website, choose a pick up location and choose the charity that will receive the profits.`,
		},
		'distribution-stations': {
			title: 'Distribution Stations',
			description: `There are hundreds of pick up locations throughout Israel so you can choose one close to your home.`,
		},
		'associations': {
			title: 'Associations',
			description: `'Matanot Ktanot' allows you to choose from over 100 different charities to which to donate the proceeds of the sale of the Mishloach Manot you purchase.`,
		},
		'prices': {
			title: 'Prices',
			description: ``,
		},
		'who-are-we': {
			title: 'Who Are We',
			description: `We are a group of friends that started Matanot Ktanot in order to give you the opportunity to purchase Mishloach Manot quickly and easily while donating the profits to a charity of your choice. None of us receives a salary; we are all volunteering our time.`,
		},
		'common-questions': {
			title: 'Common Questions',
			description: `Want to know more? Find all the answers here. `,
		},
		'contact-us': {
			title: 'Contact Us',
			description: `At "Matanot Ktanot" we are always available for feedback and requests. Click the link and we will get back to you shortly.`,
		},
		'purchase': {
			title: 'Purchase',
			description: `Matanot Ktanot allows you to purchase Mishloach Manot quickly and easily. Click to get started.`,
		},
		'login': {
			title: 'Log In',
			description: `Log in to find your order, change or cancel your order, change the pick-up location or print your receipt.`
		},
		'profile': {
			title: 'Profile',
			description: ``
		}
	},
});

export default helmetResource;